import { Box, CircularProgress, Flex, Link, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { CheckboxCmp } from '../../../components/CheckboxCmp'
import { ModalPoliticaPrivacidade } from '../../../components/ModalPoliticaPrivacidade'
import { SelectCmp } from '../../../components/SelectCmp'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { appApi } from '../../../services/appApi'
import { FormatarMensagemEditorDeTexto } from '../../../Utils/Helper'
import { Body } from '../../Layouts/Body'
import { Container, HeaderContainer } from './styles'

interface iAberturaPesquisa {
  id: string
  nomePesquisa: string
  msgAbertura?: string
  dataInicio?: string
  dataFim?: string
  status: number
  logoEmpresa: string
  traducoes?: iTraducao[]
  modoPesquisa?: number
  avaliacaoId?: string
}

interface iTraducao {
  idioma: string
  texto: string
  competencia?: string
}

export const AberturaPesquisa: React.FC = () => {
  const param = useParams<{ tokenId: string }>()
  const nav = useNavigate()
  const [idioma, setIdoma] = useState<string>('pt-BR')
  const [ModelPrivacidadeIsOpen, setModelPrivacidadeIsOpen] = useState(false)
  const [labelBtn, setLabelBtn] = useState<string>('Responder pesquisa')
  const [isAccepted, setIsAccepted] = useState<Boolean>(false)
  const [isLoading, setIsLoading] = useState<Boolean>(true)
  const [Pesquisa, setPesquisa] = useState<iAberturaPesquisa>({
    id: '',
    nomePesquisa: '',
    dataInicio: '',
    dataFim: '',
    msgAbertura: '',
    status: 0,
    logoEmpresa: ''
  })

  function obterTraduzido(ptBR: string, enUs: string, esES: string): string {
    return idioma === 'pt-BR'
      ? ptBR
      : idioma === 'en-US'
        ? enUs
        : esES
  }

  function getPesquisa(): void {
    setIsLoading(true)
    appApi.get(`TokenPesquisa/Abertura/${param.tokenId ?? ''}`)
      .then(res => {
        setPesquisa(res.data)
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setPesquisa({ ...Pesquisa, status: err.response.status === 404 ? -2 : -1 })
        setIsLoading(false)
      })
  }

  function ObterData(data: string): string {
    data = data.replace('às', '-')
    if (idioma === 'en-US') {
      const [dia, mes, ano] = data.split('/')
      return `${mes}/${dia}/${ano}`
    }
    return data
  }

  useEffect(() => {
    getPesquisa()
  }, [])

  return (
    <Body>
      <ModalPoliticaPrivacidade
        isOpen={ModelPrivacidadeIsOpen}
        onClose={() => setModelPrivacidadeIsOpen(false)}
      />
      <WhiteContainer padding='0'>
        {isLoading && (
          <HeaderContainer>
            <Flex justifyContent={'center'} w={'full'} my={'8rem'} alignItems={'center'} gap={'.75rem'}>
              <CircularProgress size={38} isIndeterminate color='var(--Azul)' />
              <h3>
                Carregando sua pesquisa
              </h3>
            </Flex>

            <img alt='Logo da empresa' src={Pesquisa.logoEmpresa ?? 'https://sigah.blob.core.windows.net/onboard/f99445d7-d98d-48ad-9cdb-a443a9f636a2.png'} />
          </HeaderContainer>)}

        {!isLoading && (
          <>
            <HeaderContainer>
              <h1>{Pesquisa.nomePesquisa}</h1>
              <img alt='Logo da empresa' src={Pesquisa.logoEmpresa ?? 'https://sigah.blob.core.windows.net/onboard/f99445d7-d98d-48ad-9cdb-a443a9f636a2.png'} />
            </HeaderContainer>
            <Box bg='var(--DegradeAzul)' className={'gradient-blue'} h={'3px'} w={'full'}></Box>
          </>)}
        {!isLoading && (
          <Container>
            {Pesquisa.traducoes && (
              <Flex direction={'column'}>
                <SelectCmp title={obterTraduzido('Selecione o idioma da pesquisa (Other languages, otros idiomas) ', 'Select survey language (Outros idiomas, otros idiomas)', 'Seleccione el idioma de encusta (Other languages, outros idiomas)')} OnChange={(e) => {
                  setIdoma(e)
                  setLabelBtn(Pesquisa.traducoes?.find(i => i.idioma === e)?.texto ?? 'Responder a pesquisa em português')
                }}
                  value={idioma} >
                  <option value={'pt-BR'} >Responder a pesquisa em português (pt-BR)</option>
                  {Pesquisa.traducoes.map(p => (
                    <option value={p.idioma}>{p.texto} ({p.idioma})</option>
                  )
                  )}
                </SelectCmp>
              </Flex>

            )}

            <Box mt={'.75rem'}>
              {Pesquisa.status === -2 && (
                <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'center'} width={'auto'} marginTop={'2rem'}>
                  <h1>{obterTraduzido('Houve um problema de conexão, tente novamente mais tarde', 'There was a connection problem, please ', 'Hubo un problema de conexión, por favor intenta nuevamente más tarde.')}</h1>
                </Flex>
              )}

              {Pesquisa.status === -1 && (
                <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'center'} width={'auto'} marginTop={'2rem'}>
                  <h1>{obterTraduzido('Esta pesquisa não está mais disponível', 'This survey is no longer available', 'Esta encuesta ya no está disponible')}</h1>
                </Flex>
              )}

              {Pesquisa.status === 0 && (
                <>
                  <main>
                    <section>
                      <span dangerouslySetInnerHTML={{ __html: FormatarMensagemEditorDeTexto(Pesquisa.msgAbertura ?? '') }}></span>
                      <br />
                      <br />
                    </section>
                    <Flex flexDir={'column'} gap={'.75rem'}>
                      <Text fontSize={'1rem'} lineHeight={'1.125rem'}>
                        {obterTraduzido(' Essa pesquisa estará disponível de',
                          'This survey will be available from',
                          'Esta encuesta estará disponible desde')} <strong>{ObterData(Pesquisa.dataInicio ?? '')}
                          {obterTraduzido(' até ', ' to ', ' hasta ')} {ObterData(Pesquisa.dataFim ?? '')}.</strong>
                      </Text>
                      <Text fontSize={'1rem'} lineHeight={'1.125rem'}>{obterTraduzido('Para iniciar o preenchimento da pesquisa, clique no botão abaixo. Ao clicar, você estará concordando com nossa política de privacidade, disponível nesse',
                        'To start answering the survey, click the button below. By clicking, you are agreeing to our privacy policy, available at this',
                        'Para comenzar a completar la encuesta, haga clic en el botón de abajo. Al hacer clic, aceptas nuestra política de privacidad, disponible en este')}
                        &nbsp;link:&nbsp;
                        <Link
                          href="https://sah.arquiteturahumana.com.br/Privacidade"
                          isExternal
                          fontWeight={'bold'}
                          textDecoration={'underline'}
                        >
                          {obterTraduzido(
                            ' Política de privacidade.',
                            ' Privacy Policy.',
                            ' Política de privacidad.')}
                        </Link>
                      </Text>
                    </Flex>
                  </main>
                  <Flex marginTop={'3.5rem'} direction={'column'}>

                    <Flex flexDir={'column'} gap={'.325rem'} alignItems={'center'} justifyContent={'center'} w={'full'}>
                      <Flex alignItems={'center'} mb={'.5rem'} sx={{ label: { paddingTop: '.5rem', paddingBottom: '.5rem' } }}>
                        <CheckboxCmp
                          fontSize='1rem'
                          OnChange={(e) => setIsAccepted(e)}
                        >{obterTraduzido(
                          'Aceito os termos e política de privacidade',
                          'I accept the terms and privacy policy',
                          'Acepto los términos y política de privacidad')}</CheckboxCmp>
                      </Flex>
                      {isAccepted && (
                        <ButtonCmp
                          VarColor='DegradeAzul'
                          w={['100%', '32rem']}
                          h={['2.75rem', '1.925rem']}
                          fontSize={['16px', '14px']}
                          onClick={() => nav({
                            pathname: Pesquisa.modoPesquisa !== 1
                              ? '/RespostaPesquisa'
                              : '/RespostaPesquisaIndicativa'
                          },
                          { state: { tokenId: param.tokenId, idioma: idioma } })}
                        >{labelBtn}</ButtonCmp>
                      )}

                      {!isAccepted && (
                        <ButtonCmp
                          VarColor='Green2'
                          w={['100%', '32rem']}
                          h={['2.75rem', '1.925rem']}
                          fontSize={['16px', '14px']}
                          isDisabled
                        >{labelBtn}</ButtonCmp>
                      )}
                      <Text fontSize={'.813rem'} fontWeight={'700'} color={'var(--Gray3)'} _hover={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setModelPrivacidadeIsOpen(true)}>{obterTraduzido(
                        'Você precisa aceitar os termos e política de privacidade para continuar.',
                        'You must accept the terms and privacy policy, before continue survey.',
                        'Debe aceptar los términos y la política de privacidad para continuar.')}</Text>
                    </Flex>
                  </Flex>
                </>
              )}

              {(Pesquisa.status === 1) && (/// Não iniciada
                <main>
                  <section>
                    <span dangerouslySetInnerHTML={{ __html: FormatarMensagemEditorDeTexto(Pesquisa.msgAbertura ?? '') }} ></span>
                    <br />
                    <br />
                  </section>
                  <p>
                    {obterTraduzido(
                      'Essa pesquisa estará disponível em',
                      'This survey will be available at',
                      'Esta encuesta estará disponible en')} <strong>{ObterData(Pesquisa.dataInicio ?? '')}
                      {obterTraduzido(' e se encerrará em', 'and will close in', 'y se cerrará en')} {ObterData(Pesquisa.dataFim ?? '')}.</strong>
                  </p>
                  <p>{obterTraduzido('A partir da data de início, você poderá responder neste mesmo link.',
                    'From the start date, you will be able to respond through this same link.',
                    'A partir de la fecha de inicio, podrá responder a través de este mismo enlace.')}

                  </p>
                  <p>{obterTraduzido('Te vejo em breve', 'Hasta luego', 'See you later')}</p>
                </main>
              )}

              {Pesquisa.status === 2 && (
                <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'center'} width={'auto'} marginTop={'2rem'}>
                  <h1>{obterTraduzido('Pesquisa já encerrada', 'Survey already closed', 'Encuesta ya cerrada')}</h1>
                </Flex>
              )}

              {Pesquisa.status === 3 && (
                <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'center'} width={'auto'} marginTop={'2rem'}>
                  <h2>Você já respondeu essa pesquisa!</h2>
                  <h3>Estamos aguardando os demais participantes responderem!</h3>

                  {Pesquisa.traducoes && (

                    <>
                      <br />
                      <br />    <br />
                      <br />
                      <h2>You already answered this survey!</h2>
                      <h3>  We are waiting for the other participants to respond!</h3>
                      <br />
                      <br />
                      <h2>¡Ya respondiste esta encuesta!</h2>
                      <h3>¡Estamos esperando a que los demás participantes respondan!</h3>
                      <br />
                    </>
                  )}
                </Flex>
              )}
            </Box>
          </Container>)}
      </WhiteContainer>
    </Body>
  )
}
